import queryString from 'query-string';
import type { WorkflowTransitions } from '../../../common/types';
import type { ScreensFilter, GetScreensRequestParams } from '../types';

const buildQueryString = (filterParams?: ScreensFilter): string => {
	const { pageSize = 10, pageNumber = 1, expand, searchFilter, orderBy } = filterParams || {};
	const maxResults = pageSize;
	const startAt = (pageNumber - 1) * maxResults;

	let requestParams: GetScreensRequestParams = { startAt, maxResults, scope: 'GLOBAL' };

	if (expand != null) {
		requestParams = { ...requestParams, expand: expand.join(',') };
	}

	if (searchFilter != null && searchFilter.length !== 0) {
		requestParams = { ...requestParams, queryString: searchFilter };
	}

	if (orderBy != null) {
		requestParams = { ...requestParams, orderBy };
	}

	return queryString.stringify(requestParams);
};

export const buildConfigureScreenJSPUrl = (screenId: string): string =>
	`/secure/admin/ConfigureFieldScreen.jspa?id=${screenId}`;

export const buildEditScreenJSPUrl = (screenId: string): string =>
	`/secure/admin/EditFieldScreen!default.jspa?id=${screenId}`;

export const buildCopyScreenJSPUrl = (screenId: string): string =>
	`/secure/admin/ViewCopyFieldScreen.jspa?id=${screenId}`;

export const buildDeleteScreenJSPUrl = (screenId: string): string =>
	`/secure/admin/ViewDeleteFieldScreen.jspa?id=${screenId}`;

export const buildScreenSchemeJSPUrl = (screenSchemeId: string): string =>
	`/secure/admin/ConfigureFieldScreenScheme.jspa?id=${screenSchemeId}`;

export const buildWorkflowSchemeJSPUrl = (workflowTransition: WorkflowTransitions): string => {
	if (workflowTransition.workflowStepId === null) {
		return `/secure/admin/ViewWorkflowTransition.jspa?${queryString.stringify({
			workflowMode: workflowTransition.workflowMode,
			workflowName: workflowTransition.workflowName,
			workflowTransition: workflowTransition.workflowTransitionId,
		})}`;
	}

	return `/secure/admin/ViewWorkflowTransition.jspa?${queryString.stringify({
		workflowMode: workflowTransition.workflowMode,
		workflowName: workflowTransition.workflowName,
		workflowStep: workflowTransition.workflowStepId,
		workflowTransition: workflowTransition.workflowTransitionId,
	})}`;
};

export const buildScreensUrl = (filterParams?: ScreensFilter): string =>
	`/rest/api/3/screens?${buildQueryString(filterParams)}`;

export const buildCreateScreenUrl = (): string => '/rest/api/3/screens';

export const buildWfeUrlWithTransitionId = ({
	workflowId,
	workflowTransitionId,
}: WorkflowTransitions) =>
	`/jira/settings/issues/workflows/${workflowId}?transitionId=${workflowTransitionId}`;
